"use client"

import { useState, useEffect } from "react"
import { supabase } from "../../supabaseClient"
import { useAuth } from "../../context/AuthContext"
import { ensureInstitutionOnPayload } from "../../lib/tenant"
import "../../styles/SalaForm.css"

export default function SalaForm({ onAdded, salaParaEditar, onCancelEdit }) {
  const { isAdmin, instituicaoId } = useAuth()
  const [nome, setNome] = useState("")
  const [capacidade, setCapacidade] = useState("")
  const [loading, setLoading] = useState(false)
  const [mensagem, setMensagem] = useState("")
  const [isEditing, setIsEditing] = useState(false)

  useEffect(() => {
    if (salaParaEditar) {
      setIsEditing(true)
      setNome(salaParaEditar.nome || "")
      setCapacidade(salaParaEditar.capacidade || "")
    } else {
      resetForm()
    }
  }, [salaParaEditar])

  const resetForm = () => {
    setIsEditing(false)
    setNome("")
    setCapacidade("")
    setMensagem("")
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!nome || !capacidade) {
      setMensagem("Preencha todos os campos obrigatórios!")
      return
    }

    setLoading(true)
    setMensagem("")

    try {
      const salaData = {
        nome,
        capacidade: Number.parseInt(capacidade),
      }

      if (isEditing && salaParaEditar) {
        const { error } = await supabase.from("salas").update(salaData).eq("id", salaParaEditar.id)

        if (error) throw error
        if (onCancelEdit) onCancelEdit()
      } else {
        const payload = ensureInstitutionOnPayload({
          ...salaData,
          created_at: new Date().toISOString(),
        }, isAdmin, instituicaoId)
        const { error } = await supabase.from("salas").insert([payload])
        if (error) throw error
      }

      resetForm()
      if (onAdded) onAdded()
    } catch (err) {
      setMensagem("Erro ao salvar sala: " + err.message)
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  const handleCancelar = () => {
    resetForm()
    if (onCancelEdit) onCancelEdit()
  }

  return (
    <form className="sala-form" onSubmit={handleSubmit}>
      <h2 className="form-title">{isEditing ? "Editar Sala" : "Adicionar Nova Sala"}</h2>

      <div className="form-grid">
        <div className="form-group">
          <label>
            Nome da Sala <span className="required">*</span>
          </label>
          <input
            type="text"
            placeholder="Ex: Sala 101, Laboratório A"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            className="form-input"
            required
          />
        </div>

        <div className="form-group">
          <label>
            Capacidade <span className="required">*</span>
          </label>
          <input
            type="number"
            placeholder="Número de lugares"
            value={capacidade}
            onChange={(e) => setCapacidade(e.target.value)}
            className="form-input"
            min="1"
            required
          />
        </div>
      </div>

      {mensagem && <p className="mensagem erro">{mensagem}</p>}

      <div className="form-actions">
        {isEditing && (
          <button type="button" className="btn-cancelar" onClick={handleCancelar}>
            Cancelar
          </button>
        )}
        <button type="submit" className="btn-salvar" disabled={loading}>
          {loading ? "Salvando..." : isEditing ? "Atualizar" : "Salvar"}
        </button>
      </div>
    </form>
  )
}
